import XEUtils from 'xe-utils'

export default {
  hasValue: function (val) {
    return val !== 'undefined' && val != null && val !== ''
  },
  toString: function (val) {
    if (this.hasValue(val)) {
      return `${val}`
    } else {
      return ''
    }
  },
  clone: function (obj, deep) {
    return XEUtils.clone(obj, deep)
  }
}
